export default __webpack_public_path__ + "static/media/reports.b08ae831.svg";